@value layoutPadding: 16px;

.page-content-previewable-layout {
    display: flex;
    justify-content: space-between;
    height: calc(100% - layoutPadding * 2);
    padding: layoutPadding;
}

.page-content {
    width: 50%;
    padding-right: 8px;
    margin-right: 8px;
    overflow-y: auto;
}

.preview-content {
    width: 50%;
    overflow: hidden;
}

.preview-content-inner {
    display: inline-block;
    width: 100%;
    transform-origin: center center;
}
